import React from "react";
import { Link, SpaceBetween, StatusIndicator } from "@cloudscape-design/components";
import { isMajorVersionUpgrade } from "src/core/util/version";
import {
    AT_RISK_LABEL,
    DependencyTableRow,
    hasRecommendedVersion,
    NOT_AVAILABLE,
} from "./helpers";
import { MajorVersionUpgradePopover } from "./popovers";

export const vendorGuidanceStatusCell = (status?: string): React.ReactNode => {
    const value = status || "-";
    if (
        value === "END_OF_LIFE" ||
        value === "DEPRECATED" ||
        value === "RECALLED"
    ) {
        return <StatusIndicator type="error">{value}</StatusIndicator>;
    }
    if (
        value === "AT_RISK" ||
        value === "UNSTABLE" ||
        value === "EXPERIMENTAL"
    ) {
        return <StatusIndicator type="warning">{value}</StatusIndicator>;
    }
    return value;
};

export const recommendedVersionCell = (
    row: DependencyTableRow,
    showMajorVersionUpgradeInfo = false,
): React.ReactNode => {
    if (row.riskStatus === "HIGH_RISK") {
        return (
            <Link
                external
                href={`https://code.amazon.com/packages/${row.dependencyName}/releases`}
            >
                Seek alternative dependency
            </Link>
        );
    }
    const version = row.recommendedVersion;
    if (!hasRecommendedVersion(version)) return NOT_AVAILABLE;
    if (
        showMajorVersionUpgradeInfo &&
        row.riskStatus === "LOW_RISK" &&
        isMajorVersionUpgrade(row.version, version)
    ) {
        return (
            <SpaceBetween direction="horizontal" size="xxs" alignItems="center">
                <span>{version}</span>
                <MajorVersionUpgradePopover
                    dependencyName={row.dependencyName}
                    version={row.version}
                    recommendedVersion={version}
                />
            </SpaceBetween>
        );
    }
    return version;
};

export const riskStatusCell = (status?: string): React.ReactNode => {
    const risk = status || "-";
    if (risk === "HIGH_RISK") {
        return (
            <StatusIndicator type="error">
                <b>{risk}</b>
            </StatusIndicator>
        );
    }
    if (risk === "LOW_RISK") {
        return (
            <StatusIndicator type="warning">
                <b>{AT_RISK_LABEL}</b>
            </StatusIndicator>
        );
    }
    if (risk === "UPGRADE_AVAILABLE") {
        return <StatusIndicator type="info">{risk}</StatusIndicator>;
    }
    if (risk === "NO_ACTION_REQUIRED") {
        return <StatusIndicator type="success">{risk}</StatusIndicator>;
    }
    return risk;
};
